/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentsControllerGetVersionHistoryQueryResponse, DocumentsControllerGetVersionHistoryPathParams, DocumentsControllerGetVersionHistory401, DocumentsControllerGetVersionHistory403 } from "../../models/documentsController/DocumentsControllerGetVersionHistory";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { documentsControllerGetVersionHistory } from "../../clients/documentsService/documentsControllerGetVersionHistory";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const documentsControllerGetVersionHistoryQueryKey = (id: DocumentsControllerGetVersionHistoryPathParams["id"]) => [{
  url: '/api/v1/documents/:id/versions',
  params: {
    id: id
  }
}] as const;
export type DocumentsControllerGetVersionHistoryQueryKey = ReturnType<typeof documentsControllerGetVersionHistoryQueryKey>;
export function documentsControllerGetVersionHistoryQueryOptions(id: DocumentsControllerGetVersionHistoryPathParams["id"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = documentsControllerGetVersionHistoryQueryKey(id);
  return queryOptions<DocumentsControllerGetVersionHistoryQueryResponse, ResponseErrorConfig<DocumentsControllerGetVersionHistory401 | DocumentsControllerGetVersionHistory403>, DocumentsControllerGetVersionHistoryQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return documentsControllerGetVersionHistory(id, config);
    }
  });
}

/**
 * @summary Get version history for a document
 * {@link /api/v1/documents/:id/versions}
 */
export function useDocumentsControllerGetVersionHistory<TData = DocumentsControllerGetVersionHistoryQueryResponse, TQueryData = DocumentsControllerGetVersionHistoryQueryResponse, TQueryKey extends QueryKey = DocumentsControllerGetVersionHistoryQueryKey>(id: DocumentsControllerGetVersionHistoryPathParams["id"], options: {
  query?: Partial<QueryObserverOptions<DocumentsControllerGetVersionHistoryQueryResponse, ResponseErrorConfig<DocumentsControllerGetVersionHistory401 | DocumentsControllerGetVersionHistory403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? documentsControllerGetVersionHistoryQueryKey(id);
  const query = useQuery({
    ...documentsControllerGetVersionHistoryQueryOptions(id, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<DocumentsControllerGetVersionHistory401 | DocumentsControllerGetVersionHistory403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}